import { HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigApiInterface, InternalResponseInterface, WorldInfoInterface } from 'src/app/home/object-info/model/config-api-response.interface';
import { UtilsService } from '../utils.service';

@Injectable({
    providedIn: 'root'
})
export class DynamicConfigService {
    // World info of the currently selected feature.
    private config: ConfigApiInterface;
    public onChange: EventEmitter<ConfigApiInterface> = new EventEmitter();

    constructor(
        private utils: UtilsService,
    ) { }

    async fetchConfig() {
        let url = this.utils.creaURL('restrictedArea', 'config');

        // todo: extract param from config globale
        const body = new HttpParams().append('application', 'nam');
        const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');
        this.config = await (this.utils.postRequest(url, body, false, { headers }) as Observable<ConfigApiInterface>).toPromise();

        console.log();

        // Notify subscribers about the change.
        this.onChange.emit(this.config);
    }

    getConfig() {
        return this.config;
    }
}
